import GradientBorder from "@core-components/gradient-border/GradientBorder";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button } from "@mantine/core";
import { useLoaderStore } from "@modules/loader/useLoader.hook";
import useRankedDetailsModalStore from "@store/rankedDetails.store";

interface ISSRankedCardFooterProps {
  puuid: string;
}

const SSRankedCardFooter: React.FC<ISSRankedCardFooterProps> = ({ puuid }) => {
  const { t } = useAppTranslation("components.rankedCard");
  const { open } = useRankedDetailsModalStore();
  const { isLoading } = useLoaderStore();

  return (
    <GradientBorder
      className="gradient-gray-to-light-white hover-scale rounded-xl"
      childrenClassName="p-[6px] !bg-primary-default"
    >
      <Button
        className="default-icon w-full rounded-xl bg-primary-default text-[16px] text-primary-white hover:bg-inherit hover:text-primary-white "
        px={14}
        onClick={() => open(puuid)}
        loading={isLoading()}
      >
        {t("seeDetails")}
      </Button>
    </GradientBorder>
  );
};

export default SSRankedCardFooter;
